import { useSelector, useDispatch } from "react-redux";
import { State } from "@App/state";
import { useQuery } from "@apollo/client";
import { GET_ORGANIZATION_NETWORK, OrganizationNetworkQuery } from "@App/graphql/queries";
import { setNetwork } from "@App/state/action-creators";
import { useEffect } from "react";

/**
 * Fetches the network the network selector picks for the currently selected service and brand
 * and stores it in the state. The query only runs once both service and brand are selected.
 */
export const useNetwork = () => {
  const dispatch = useDispatch();

  const organization = useSelector((state: State) => state.orders.organization);
  const service = useSelector((state: State) => state.orders.service);
  const brand = useSelector((state: State) => state.orders.brand);
  const driver = useSelector((state: State) => state.auth?.driverData?.uuid);
  const presetFilters = useSelector((state: State) => state.filters.presetFilters);

  const skip = !organization || !service || !brand;

  const { loading, data, error } = useQuery<OrganizationNetworkQuery>(GET_ORGANIZATION_NETWORK, {
    variables: {
      organization: organization ? organization.id : null,
      services: service ? [service.id] : null,
      brand: brand ? brand.id : null,
      driver: driver,
      presetFilters: presetFilters,
    },
    skip: skip,
  });

  const network = skip ? null : (data?.organization?.network ?? null);

  useEffect(() => {
    dispatch(setNetwork(network));
  }, [network]);

  return {
    loading: loading,
    error: error,
    network: network,
  };
};
